// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		collageNumber: 3,
		showPlaceholderProductList: true,
	}
};


(function() {
	BoostPFS.inject(this);

	/************************** BUILD PRODUCT LIST **************************/

	// Build Product Collage Item
	ProductCollageItem.prototype.compileTemplate = function(data, index, totalProduct) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		if (!totalProduct) totalProduct = this.totalProduct;

		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productCollageItemHtml;

		// Wrapper for collage
		var startCollageWrapper = '';
		var endCollageWrapper = '';
		// Grid Width class
		var itemGridWidthClass = boostPFSThemeConfig.custom.grid_item_width;

		itemHtml = itemHtml.replace(/{{startCollageWrapper}}/g, startCollageWrapper);
		itemHtml = itemHtml.replace(/{{endCollageWrapper}}/g, endCollageWrapper);
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add soldOut and onSale label
		if (soldOut) {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, boostPFSTemplate.soldOutLabelHtml);
		} else {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
			if (onSale) {
				itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, boostPFSTemplate.saleLabelHtml.replace(/{{saleLabel}}/g, boostPFSThemeConfig.label.save_price));
				itemHtml = itemHtml.replace(/{{ saved_amount }}/g, Utils.formatMoney(data.compare_at_price_min - data.price_min, Globals.moneyFormat));
			}
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, '');

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], 'grande') : Settings.getSettingValue('general.no_image_url');
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		// var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
		// itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
		var itemVendorHtml = true ? boostPFSTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
		}
		if (priceVaries) {
			itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			itemPriceHtml += '<span class="icon-fallback-text"><span class="icon icon-plus grid-product__price-min" aria-hidden="true"></span><span class="fallback-text">+</span></span>';
		} else {
			itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data, index) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add soldOut class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		// Add soldOut and onSale label
		if (soldOut) {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, boostPFSTemplate.soldOutLabelHtml);
		} else {
			itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, '');
			if (onSale) {
				itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, boostPFSTemplate.saleLabelHtml.replace(/{{saleLabel}}/g, boostPFSThemeConfig.label.save_price));
				itemHtml = itemHtml.replace(/{{ saved_amount }}/g, Utils.formatMoney(data.compare_at_price_min - data.price_min, Globals.moneyFormat));
			}
		}
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, '');

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var img_id_class = 'ProductCardImage-{{itemId}}';
		var wrapper_id = 'ProductCardImageWrapper-{{itemId}}';
		var itemImagesHtml = '';
		if (images.length > 0) {
			var aspect_ratio = images[0]['width'] / images[0]['height'];

			itemImagesHtml += '<div id="' + wrapper_id + '" class="product--wrapper">';
			itemImagesHtml += '<div style="padding-top:' + (1 / aspect_ratio * 100) + '%;">' +
									'<img class="product--image lazyload ' + img_id_class + '"' +
									' src="' + Utils.getFeaturedImage(images, '150x150') +  '"' +
									' data-src="' + Utils.getFeaturedImage(images, '{width}x') + '"' +
									' data-widths="[180, 370, 590, 740, 900, 1080, 1296, 1512, 1728, 2048]"' +
									' data-aspectratio="' + aspect_ratio + '"' +
									' data-sizes="auto"' +
									' alt="{{itemTitle}}">' +
								'</div>';
			itemImagesHtml += '</div>';
			itemImagesHtml += '<noscript><img class="grid-product__image" src="' + Utils.getFeaturedImage(images, '1024x') + '" alt="{itemTitle}}"></noscript>';
		} else {
			itemImagesHtml += '<img class="grid-product__image" src="' + Utils.getFeaturedImage(images, '1024x') + '" alt="{{itemTitle}}">';
		}
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		console.log("[DEBUG] enter_enable VALUE =" + boostPFSThemeConfig.custom.vendor_enable);
		var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{vendor}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.sale_price + '</span>';
		} else {
			itemPriceHtml += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>';
		}
		if (priceVaries) {
			itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
			itemPriceHtml += '<span class="icon-fallback-text"><span class="icon icon-plus grid-product__price-min" aria-hidden="true"></span><span class="fallback-text">+</span></span>';
		} else {
			itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add data json
		var itemJson = {
			"id": data.id,
			"title": data.title,
			"handle": data.handle,
			"vendor": data.vendor,
			"variants": data.variants,
			"url": Utils.buildProductItemUrl(data),
			"options_with_values": data.options_with_values,
			"images": data.images,
			"available": data.available,
			"price_min": data.price_min,
				"price_max": data.price_max,
				"compare_at_price_min": data.compare_at_price_min,
				"compare_at_price_max": data.compare_at_price_max,
		};
		itemHtml = itemHtml.replace(/{{itemJson}}/g, JSON.stringify(itemJson));

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	function buildImageStyle(data) {
		var images = data.images_info;
		var img_id_class = 'ProductCardImage-{{itemId}}';
		var wrapper_id = 'ProductCardImageWrapper-{{itemId}}';
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSThemeConfig.custom.max_height;
			var height = boostPFSThemeConfig.custom.max_height;
			var small_style = true;
			var aspect_ratio = image.width / image.height;

			if (aspect_ratio <= 1) {
				var max_width = height * aspect_ratio;
				if (image.height < height) {
					var max_height = image.height;
					var max_width = image.width;
				} else {
					var max_height = height;
				}
			} else {
				var max_height = width / aspect_ratio;
				if (image.width < width) {
					var max_height = image.height;
					var max_width = image.width;
				} else {
					var max_width = width;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 591px) {';
				imageStyle +=   '.' + img_id_class +' {' +
									'max-width: ' + max_width + 'px;' +
									'max-height: ' + max_height + 'px;' +
								'}' +
								'#' + wrapper_id + ' {' +
									'max-width: ' + max_width + 'px;' +
								'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio <= 1) {
					max_width = 295 * aspect_ratio;
				} else {
					if (image.width < 590) {
						max_width = image.width;
					} else {
						max_width = 590;
					}
				}
				imageStyle +=   '@media screen and (max-width: 590px) {'
									'.' + img_id_class + '{' +
										'max-width: {{ max_width }}px;' +
									'}' +
									'#' + wrapper_id + '{' +
										'max-width: {{ max_width }}px;' +
									'}' +
								'}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	/************************** END BUILD PRODUCT LIST **************************/


	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage -1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	ProductItem.prototype.beforeRender = function() {
    if (!this.$element && Globals.queryParams.display == ProductList.Enum.itemStyle.COLLAGE) {
      if (this.parent.isRender()) {
        // On none first load, render element from template
        this.$element = jQ(this.compileTemplate());
      } else {
        // On first load, select element from the DOM
        this.$element = this.$productList.find('.grid__item.grid-product').eq(this.index);
      }
    }
  }

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;

		var collageNumber = Settings.getSettingValue('general.collageNumber');
		var row = 0;
		var $products = this.$element.children('.grid__item.grid-product');

		for (var i = 0; i < data.length; i++) {
			$products.eq(i).addClass("medium--one-half large--one-third");
		}

		/*
		for (var i = 0; i < data.length; i++) {
			var is_reverse_row__product = (row % 2) == 0? false: true; 
			var colIndex = i % collageNumber;
			// Group 3 product item to a collage
			if (colIndex == 0) {
				$products.slice(i, i + collageNumber)
					.wrapAll('<div class="grid__item collage-grid__row"><div class="grid"></div></div>')
					.parents('.grid__item.collage-grid__row')
					.after('<div class="grid__row-separator"></div>');
				// Group 2 item for the reverse block
				if (is_reverse_row__product) {
					$products.slice(i, i + 2).wrapAll('<div class="grid__item collage-grid__reverse--wrapper one-whole medium--one-third large--one-third"><div class="grid"></div></div>');
				}
			} else if (colIndex == (collageNumber - 1)) {
				row++
			}
			
			var itemGridWidthClass = '';
			switch(colIndex) {
				case 0:
					if (is_reverse_row__product) {
						itemGridWidthClass = 'grid__item--small one-whole reverse';
					} else {
						itemGridWidthClass = 'grid__item--large one-whole medium--two-thirds large--two-thirds';	
					}
					break;
				case 1:
					if (is_reverse_row__product) {
						itemGridWidthClass = 'grid__item--small one-whole reverse';
					} else {
						itemGridWidthClass = 'grid__item--small one-whole medium--one-third large--one-third';
					}
					break;
				case 2:
					if (is_reverse_row__product) {
						itemGridWidthClass = 'grid__item--large one-whole medium--two-thirds large--two-thirds reverse clearfix';
					} else {
						itemGridWidthClass = 'grid__item--small one-whole medium--one-third large--one-third clearfix';
					}
					break;
				default:
					break;
			}
			
			$products.eq(i).addClass(itemGridWidthClass);
		}
		*/

		jQ(document).ready(function() {
			theme.init();
			var sections = new theme.Sections();
			sections.register('collection-template', theme.Collection);
		});
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
	};

	// Build placeholder for Collage product
	ProductListPlaceholder.prototype.compileTemplateExtra = function(eventType){
		var display = Globals.queryParams.display;
		var html;
		if(typeof display !== 'undefined' && display == 'collage') {
			html = boostPFSTemplate.skeletonProductCollage;
		}

		//console.log(html, 'Boost placeholder template');
		return html
			.replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
			.replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
			.replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText);
	}

	// Build Default layout
	Filter.prototype.errorFilterCallback=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=Utils.isSearchPage()&&Glocals.queryParams.hasOwnProperty("q")?"&q="+Glocals.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};
})();
